module.exports = __webpack_public_path__ + "static/img/016.e281bb30.png";